import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class CategoryIcon extends Component {
    static propTypes = {
        icon: PropTypes.string.isRequired,
        fillColor: PropTypes.string.isRequired,
        includeFill: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        fillColor: '#fff',
        includeFill: true,
    };

    constructor(props) {
        super(props);

        this.svgRe = new RegExp("^svg:(.*)/i", 'i');
        this.faRe = new RegExp("^fa", 'i');
        this.urlRe = new RegExp("^http[s]?:\\/\\/", 'i');
        this.svgTagRe = new RegExp("^<svg", 'i');
    }

    render() {
        const { icon, fillColor, includeFill } = this.props;

        let iconClassNames = null,
            iconStyle = null,
            iconHtml = null;

        const matches = this.svgRe.exec(icon);
        if (matches && matches.length > 0) {
            const iconValue = matches[0];
            if(iconValue !== 'circle') {
                const htmlAttrs = {
                    viewBox: "0 0 50 50",
                    xmlns: "http://www.w3.org/2000/svg",
                };

                if(includeFill) {
                    htmlAttrs.fill = fillColor;
                }

                iconHtml = <svg className="icon-svg" {...htmlAttrs}>
                    <path d={iconValue} />
                </svg>;
            }
        } else if (this.faRe.test(icon)) {
            iconClassNames = classNames('icon-fa', icon);
            if (includeFill) {
                iconStyle = {
                    color: fillColor,
                };
            }
            iconHtml = <span style={iconStyle} className={iconClassNames} />;
        } else if (this.urlRe.test(icon)) {
            iconClassNames = classNames('icon-img');
            iconHtml = <img className={iconClassNames} src={icon} />;
        } else if (this.svgTagRe.test(icon)) {
            iconStyle = {
                display: 'inline-block',
                height: '100%',
                width: '100%',
            };
            if(includeFill) {
                iconStyle.color = fillColor;
            }
            iconHtml = <span style={iconStyle} dangerouslySetInnerHTML={{__html: icon}} />;
        }

        return iconHtml;
    }
}
